// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"708":"eb2ee276","787":"441eb505"}[chunkId] + ".chunk.js";
};